import { HTTP_METHODS } from '@studio/constants/axios';
import { CENTRAL_API_V2 } from '@studio/constants/env-variables';
import type { Timezones } from '@studio/types';

export const root = {
  [HTTP_METHODS.GET]: {
    url: `${CENTRAL_API_V2}/timezones`,
    response: {} as Timezones.Get.V2.Timezone[],
    method: HTTP_METHODS.GET,
  },
};
